function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: l , size: a = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const s = n(), t = l !== null && l !== void 0 ? l : s ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ r("path", {
            fill: t,
            d: "M15.99 18.573a.952.952 0 01-.264-.04L10.27 16.89l-.199.632a.801.801 0 01-.403.482.782.782 0 01-.625.056l-2.269-.711a.822.822 0 01-.538-1.028l.186-.59-3.21-.966a.535.535 0 01-1.056-.122V9.36a.535.535 0 011.055-.122l12.515-3.769a.894.894 0 01.802.143.98.98 0 01.392.79v11.201a.98.98 0 01-.39.788.904.904 0 01-.54.182zm-12.731-4.91l12.59 3.792V6.55L3.26 10.34v3.322zm4.103 2.728l1.748.549.07-.224-1.748-.55-.07.225zm11.687-8.185a.545.545 0 01-.387-.933l1.546-1.546a.548.548 0 01.773.773l-1.546 1.546a.545.545 0 01-.386.16zm.067 4.109a.545.545 0 110-1.092H21.3a.545.545 0 110 1.092h-2.185zm1.084 5.431a.545.545 0 00.773 0 .548.548 0 000-.773l-1.507-1.507a.548.548 0 00-.773.773l1.507 1.507z"
        })
    }));
}, u = i;
export { u as default };
